export function downloadVCard(vcardString: string, filename: string): void {
  const blob = new Blob([vcardString], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
